import { useEffect, useContext } from 'react';
import './App.css';
import { Content } from './pages/Content';
import { Header } from './pages/Header';
import { Menu } from './pages/Menu';
import { AgentModeContext } from './context/AgentModeContext';
import {
  BefConfigContext,
  BefGlobalContext,
  BefLanguageServiceContext,
  BefMenuServiceProvider,
  BefMessageServiceContext,
  BefPage,
  BefPageControllerContext,
  BefPageControllerService,
  BefPageServiceProvider,
  BefRpcContext,
  BefSession,
} from '@beflam/bef-core';
import React from 'react';
import { ModalContainer } from './pages/ModalContainer';
import { Sheet } from './pages/Sheet';
import { BefDialogContainer } from './pages/befDialogContainer';
import { LoadingContainer } from './pages/LoadingContainer';
import { getUrlQueryParams } from './renderer/utils';
import { LibraryManager } from './assets/library-manager';
import { Subject } from 'rxjs';
import Base64 from 'crypto-js/enc-base64';
import Utf8 from 'crypto-js/enc-utf8';
import { BefPluginProxyDataService } from "./service/bef-plugin-proxy-data-service";
import { useNavigate } from 'react-router-dom';
import { AppFooter } from './pages/AppFooter';
import { createComponentPage } from './lib/renderSchemaHelper';

export function App() {
  const sConfig = useContext(BefConfigContext);
  const sGlobal = useContext(BefGlobalContext);
  const sRpc = useContext(BefRpcContext);
  const messageService = useContext(BefMessageServiceContext);
  const languageService = useContext(BefLanguageServiceContext);
  const pageController = new BefPageControllerService(messageService, sGlobal, languageService);

  const navigate = useNavigate();
  const [isSheetRegisted, setIsSheetRegisted] = React.useState(false);
  const initEvent = new Subject<any>();
  const contentInitEvent = new Subject<any>();
  const pluginPageInitEvent = new Subject<any>();

  let index = 0;
  const componentDidMount = (srcs: string[]) => {
    srcs.forEach((src) => {
      // 创建一个新的script元素
      const script = document.createElement('script');
      // 设置script元素的src属性，这里是要加载的JavaScript文件的URL
      script.src = src;
      // 定义script元素的加载完成时的回调函数
      script.onload = () => {
        // 在脚本加载完成后，可以执行你希望运行的代码
        // 这里可以调用脚本中定义的函数或执行其他操作
        index++;
        if (index === 2) setIsSheetRegisted(true);
      };
      // 将script元素添加到DOM中的head部分，开始加载脚本
      document.body.appendChild(script);
    });
  };

  let isSinglePage = false;
  let initCommandID = '';
  let moduleID = '';
  let pagemode = '';
  let isSheetShare = false;
  let commandUrlQuery = getUrlQueryParams(window.location.search);
  if (commandUrlQuery?.commandid) {
    initCommandID = commandUrlQuery.commandid;
    if (initCommandID.indexOf('DataEntityShare') > -1) {
      isSheetShare = true;
      index = 0;
      componentDidMount([
        './assets/luckysheet/plugins/js/plugin.js',
        './assets/luckysheet/luckysheet.umd.js',
      ]);
    }
  }

  const appId: string = commandUrlQuery?.appid || commandUrlQuery?.appId
  if (appId && appId.length > 0) sGlobal.currentAppId = appId;
  //这里要判断sessionSource，这个在iframe中需要设置rpcDirect
  if (commandUrlQuery?.sessionSource) sGlobal.rpcDirect = true;

  if (commandUrlQuery?.moduleid) {
    moduleID = commandUrlQuery.moduleid;
  }

  if (commandUrlQuery?.pagemode) {
    pagemode = commandUrlQuery.pagemode;
    if (pagemode === 'single') isSinglePage = true;
  }

  const agentmode = commandUrlQuery?.agentmode || '';
  const agentid = commandUrlQuery?.agentid || '';
  if (agentmode !== '' || pagemode === 'agent' || pagemode === 'documents') {
    isSinglePage = true;
    sGlobal.isSinglePage = true;
    sGlobal.rpcDirect = true; //目前暂设置如果是agent模式的话，就开启rpcDirect，防止在iframe中使用遇到问题
  }

  const openAIPage = (type: string, agent?: any, backHandler?: () => void) => {
    sGlobal.aiVisibleEvent.emit({ visible: true, type, params: { colleague: agent, backHandler } });
  };

  const openAgentPage = () => {
    sGlobal.aiVisibleEvent.emit({ visible: true, type: 'agent', params: {} });
  }

  const openNativeFileManagerPage = () => {
    sGlobal.aiVisibleEvent.emit({ visible: false });
    let page = createComponentPage('BefFileManager');
    pageController.show(page, '文档管理');
  };

  if (commandUrlQuery?.id && commandUrlQuery?.param) {
    isSinglePage = true;

    let paramStr = Base64.parse(decodeURIComponent(commandUrlQuery.param)).toString(Utf8);
    let params = JSON.parse(paramStr);
    if (!sGlobal.session) sGlobal.session = new BefSession();
    sGlobal.session.id = params.sessionID;
    sGlobal.config.host = params.uiHost;
    sGlobal.config.devApiHost = params.apiHost;
    sRpc.rpcProxyId = commandUrlQuery.id;

    BefPluginProxyDataService.init({
      id: commandUrlQuery.id,
      showInitPage: (result: any) => {
        if (!result || !result.appID || !result.pageData) return;
        let np = new BefPage(result.appID, result.pageData.ID, "Home");
        np.pageData.fromDataObject(result.data);
        pluginPageInitEvent.next(np);
      },
      savePluginParameter: (result: any) => {
        if (!pageController.activeContainer || !pageController.activeContainer.activePage) throw "插件页面未加载成功";
        return (pageController.activeContainer.activePage as any)["pluginParamSaveEvent"](result);
      },
      pluginParameterChanged: (result: any) => {
        if (!pageController.activeContainer || !pageController.activeContainer.activePage) throw "插件页面未加载成功";
        if (!(pageController.activeContainer.activePage as any)["pluginParamChangedEvent"]) throw "缺少 plugin.settingChanged 方法";
        return (pageController.activeContainer.activePage as any)["pluginParamChangedEvent"](result);
      },
      onRpcResult: (result: any) => {
        sRpc.onRpcResultAsync(result.data);
      }
    });
  }
  //这里相当于componentDidMount
  useEffect(() => {
    //如果不存在会话，需要跳转到登录界面
    if (!sGlobal.session.id) {
      navigate('/login' + window.location.search);
      return;
    }
    //因为目前必须要设置默认的appId
    if (!sGlobal.currentAppId) {
      //如果当前会话中不存在appId，并且当前global也没有，需要跳到选择应用的界面
      if (!sGlobal.session.appId) {
        if (!sRpc.rpcProxyId) {
          navigate('/app' + window.location.search); //这里不带url参数，后续需要可添加
          return;
        }
      } else {
        sGlobal.currentAppId = sGlobal.session.appId;
      }
    }

    //GetInitPara目前需要指定appType为Web，这样会返回Web对应的Permission
    if (!isSheetShare) sConfig.GetInitPara({ appType: 'Web' });

    const initEventSub = sConfig.initEvent.subscribe(async (result: any) => {
      if (isSinglePage) sGlobal.isSinglePage = isSinglePage;

      if (agentmode !== '') {
        if (agentmode === 'assistant') {
          openAIPage('', { Id: agentid, Name: agentid });
        } else if (agentmode === 'colleague') {
          openAIPage('AIUSER', { Id: agentid, Name: agentid });
        }
      } else if (pagemode === 'agent') {
        openAgentPage();
      } else if (pagemode === 'documents') {
        openNativeFileManagerPage();
      }

      if (!sRpc.rpcProxyId) {
        //开发模式使用云平台的插件
        if (process.env.NODE_ENV === 'development') {
          const ps = {
            'beflam-fusion': {
              Name: 'fusion',
              Type: 'COM',
              Version: '0.1.135',
              DesignerVersion: '0.1.24',
              Package:
                'https://resource.beflam.com/packages/@beflam/fusion/0.1.135',
            },
            'beflam-layout': {
              Name: 'layout',
              Type: 'COM',
              Version: '0.1.4',
              DesignerVersion: '0.1.24',
              Package:
                'https://resource.beflam.com/packages/@beflam/layout/0.1.4',
            },
            'beflam-table': {
              Name: 'table',
              Type: 'COM',
              Version: '0.2.74',
              DesignerVersion: '0.2.28',
              Package:
                'https://resource.beflam.com/packages/@beflam/table/0.2.74',
            },
            'beflam-echart': {
              Name: 'echart',
              Type: 'COM',
              Version: '0.1.53',
              DesignerVersion: '0.2.28',
              Package:
                'https://resource.beflam.com/packages/@beflam/echart/0.1.53',
            },
          };

          await LibraryManager.init(ps);
        } else {
          await LibraryManager.init(result.Plugin);
        }
      }
      initEvent.next(result);
      if (isSinglePage || sGlobal.isSinglePage) {
        contentInitEvent.next(result);
      }
    });

    return () => {
      initEventSub.unsubscribe();
    };
  }, []);

  return (
    <AgentModeContext.Provider value={{ openAIPage }}>
      <BefPageControllerContext.Provider value={pageController}>
        <BefMenuServiceProvider>
          {isSheetShare && isSheetRegisted && (
            <BefPageServiceProvider>
              <Sheet
                isSinglePage={isSinglePage}
                appID={moduleID}
                entitySource={initCommandID.replace('_DataEntityShare', '')}
              />
            </BefPageServiceProvider>
          )}
          {!isSheetShare && (
            <div
              id="wrapper"
              style={{
                padding: isSinglePage || sGlobal.isSinglePage ? '0px' : '',
              }}
            >
              {!isSinglePage && !sGlobal.isSinglePage && (
                <Menu initEvent={initEvent} contentInitEvent={contentInitEvent} />
              )}
              <div
                id="page-wrapper"
                className="gray-bg dashbard-1 bef-dashbard"
                style={{
                  margin: isSinglePage || sGlobal.isSinglePage ? '0px' : '',
                }}
              >
                {!isSinglePage && !sGlobal.isSinglePage && (
                  <Header initEvent={initEvent} />
                )}
                <Content
                  isSinglePage={isSinglePage || sGlobal.isSinglePage}
                  initEvent={contentInitEvent}
                  pluginPageInitEvent={pluginPageInitEvent}
                />
                {!isSinglePage && !sGlobal.isSinglePage && <AppFooter />}
              </div>
            </div>
          )}
          <ModalContainer />
          <LoadingContainer />
          <BefDialogContainer />
        </BefMenuServiceProvider>
      </BefPageControllerContext.Provider>
    </AgentModeContext.Provider>
  );
}

export default App;